export default [
    {
        path: '/pages/property/downloadTempFile',
        name: '/pages/property/downloadTempFile',
        component: () => import('@/views/property/downloadTempFile.vue')
    }
] 